<template>
  <div>
    <div class="d-flex">
      <nav id="breadcrumbs" class="mb-3">
        <ul>
          <li>
            <router-link :to="{ name: 'company.dashboard' }">
              <i class="uil-home-alt"></i> <span>
              </span>
            </router-link>
          </li>
          <li>{{ $t("users.users") }}</li>
          <li>{{ $t("general.user_list") }}</li>
        </ul>
      </nav>
    </div>

    <div v-if="successMessage" class="card">
      <div class="uk-alert-success" uk-alert>
        <a class="uk-alert-close" uk-close></a>
        <p style="color:green;">
          <i class="uil-check"></i>
          {{ successMessageText }}
        </p>
      </div>
    </div>

    <div class="section-header mb-lg-2 border-0 uk-flex-middle">
      <div class="section-header-left">
        <h2 class="uk-heading-line text-left">
          <span> {{ $t("users.users") }} </span>
        </h2>
      </div>
      <div class="section-header-right">
        <button :disabled="!$hasPermission('create_user')"
          :style="{ cursor: !$hasPermission('create_user') ? 'not-allowed' : 'pointer' }" class="btn btn-default"
          type="button" @click="$router.push({ name: 'company.user.add' })">
          <i class="uil-plus"></i> {{ $t("users.add_user") }}
        </button>
      </div>
    </div>
    <div class="card">
      <!-- Card header -->
      <div class="card-header actions-toolbar border-0 users-toolbar">
        <div class="d-flex justify-content-between users-toolbar-inner">
          <div class="uk-search uk-search-navbar users-toolbar-search">
            <i class="uil-search position-absolute"></i>
            <input v-model="filter.search" :placeholder="$t('general.search')"
              class="uk-search-input shadow-0 uk-form-small " type="search" v-on:keydown.enter.prevent="filterResult()" />
          </div>
          <div class="d-flex users-toolbar-actions">
            <div class="btn-group mr-3">
              <select v-model="per_page" class="ml-1" tabindex="-98" @change="filterResult()">
                <option value="10">10</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="500">500</option>
                <option value="1000">1000</option>
                <option value="2500">2500</option>
              </select>
            </div>
            <a :uk-tooltip="$t('filters.order.sort')" aria-expanded="false" class="btn btn-icon btn-hover  btn-circle"
              href="javascript:void(0)" title="">
              <i class="uil-list-ui-alt"></i>
            </a>
            <div class="uk-dropdown" uk-dropdown="pos: bottom-right ; mode: click ;animation: uk-animation-scale-up">
              <ul class="uk-nav uk-dropdown-nav">
                <li class="uk-active">
                  <a href="javascript:void(0)" @click="sortOrder('asc', 'name')">{{ $t("sorting.a_z") }}</a>
                </li>
                <li>
                  <a href="javascript:void(0)" @click="sortOrder('desc', 'name')">{{ $t("sorting.z_a") }}</a>
                </li>
                <li>
                  <a href="javascript:void(0)" @click="sortOrder('asc', 'id')">
                    {{ $t("sorting.created_at_old") }}</a>
                </li>
                <li>
                  <a href="javascript:void(0)" @click="sortOrder('desc', 'id')">
                    {{ $t("sorting.created_at_new") }}</a>
                </li>
              </ul>
            </div>

            <!-- Filter -->
            <a :uk-tooltip="$t('general.filter_list')" class="btn btn-icon btn-hover  btn-circle"
              href="javascript:void(0)">
              <i class="uil-filter"></i>
            </a>
            <UserFilter :has-status="true" :show-integration-filter="true" :show-role-filter="true"
                        @getFilter="getFilter($event)"></UserFilter>

            <excel-download-button :loading="isReportDownloading" :tooltipText="$t('filters.export_excell')"
              @download="exportUsers" />

          </div>
        </div>
      </div>
      <!-- Table -->
      <default-loading v-if="user_loading"></default-loading>
      <template v-else>
        <div class="d-flex justify-content-between mr-3 ml-3">
          <div>
            <span class="mr-2">{{ this.$t('general.active_users') }} : {{
              counts.active_users_count
            }}</span>
            <span class="mr-2">{{ this.$t('general.inactive_users') }} : {{
              counts.passive_users_count
            }}</span>
            <span class="mr-2">{{ this.$t('general.Total Users') }} : {{
              counts.total_users_count
            }}</span>
          </div>
          <div>
            {{ this.$t('general.number_of_selected_users') }}: <i class="uil-users-alt"></i>
            {{ selectedUsersCount }}
          </div>
        </div>
        <div class="p-3 d-flex disabled_hover users-bulk-actions">
          <button class="btn btn-sm btn-secondary mr-2 mr-auto p-2" type="button" @click="allUserToggle()">
            <i class="uil-check-square"></i> {{ selectAllUserText }}
          </button>
          <button class="btn btn-sm btn-success" type="button" @click="sendForgotPasswordMail()">
            {{ $t('general.send_forgot_password_mail') }}
          </button>

          <button class="btn btn-sm btn-success ml-2" type="button" @click="sendWelcomeMail()">
            {{ $t('general.send_welcome_mail') }}
          </button>
          <button class="btn btn-sm btn-success ml-2" type="button" @click="activeSelectedUsers()">
            <i class="uil-check"></i> {{ this.$t('general.activate_selected_users') }}
          </button>
          <button class="btn btn-sm btn-danger ml-2" type="button" @click="passiveSelectedUsers()">
            <i class="uil-minus-circle"></i> {{ this.$t('general.inactive_selected_users') }}
          </button>
          <button v-if="$hasPermission('delete_user')" class="btn btn-sm btn-secondary ml-2" type="button"
            @click="deleteSelectedUsers()">
            <i class="uil-trash"></i> {{ this.$t('general.delete_selected_users') }}
          </button>
          <button v-else :style="{
            cursor: 'not-allowed',

          }" :uk-tooltip="$t('general.no_permission')" class="btn btn-sm btn-secondary ml-2" disabled type="button">
            <i class="uil-trash"></i> {{ this.$t('general.delete_selected_users') }}
          </button>
        </div>
        <div class="table-responsive">
          <table class="table align-items-center">
            <thead>
              <tr>
                <th scope="col"></th>
                <th scope="col">
                  {{ $t("users.firstname") }} {{ $t("users.lastname") }}
                </th>
                <th scope="col">{{ $t("users.title") }}</th>
                <th v-if="!shouldHideEmailField" scope="col">{{ $t("users.user_email") }}</th>
                <th scope="col">{{ $t('general.user_status') }}</th>
                <th scope="col">{{ $t("general.group_info") }}</th>
                <th scope="col">{{ $t("users.institution") }}</th>
                <th scope="col">{{ $t("general.created_at") }}</th>
                <th scope="col">{{ $t("users.last_login_date") }}</th>
                <th scope="col">{{ $t("general.phone") }}</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody class="list">
              <template v-for="item in formattedItem">
                <tr>
                  <th>
                    <input :id="'notification_checkbox_' + item.id" v-model="item_checked" :value="item.id"
                      style="width: 15px; margin: 10px 10px 10px 0" type="checkbox" />
                  </th>
                  <th scope="row">
                    <div class="media align-items-center">
                      <div>
                        <div class="avatar-parent-child" style="width: max-content">
                          <AvatarOrIcon :size-px="32" :src="item.photo_link" />
                          <span :class="item.is_online ? 'bg-success' : 'bg-offline'
                            " class="avatar-child avatar-badge"></span>
                        </div>
                      </div>
                      <div class="media-body ml-4">
                        <a class="name h6 mb-0 text-sm" @click="openProfileModal(item)">
                          {{ item.fullname }}
                        </a>
                        <small class="d-block font-weight-bold">#{{ item.id }}</small>
                      </div>
                    </div>
                  </th>
                  <td>{{ item.title }}</td>
                  <td v-if="!shouldHideEmailField">{{ item.email }}</td>
                  <td :class="getUserStatus(item.status_id).className">{{ getUserStatus(item.status_id).text }}</td>
                  <td>
                    <div v-for="(group, index) in item.group_info" :key="index"
                      style="text-align: center;background-color: #d7f0e5;border-radius: .25rem;margin-bottom: 2px;font-weight: 600;color: #36b37e;padding: .25rem;">
                      {{ group.name }}
                    </div>
                  </td>
                  <td>{{
                    item.corporate_id == null || !item.corporate_name
                    ? item.company_name
                    : item.company_name + ' / ' + item.corporate_name
                  }}
                  </td>
                  <td>{{ item.created_at }}</td>
                  <td>{{ item.last_login_at }}</td>
                  <td>{{ item.phone }}</td>
                  <td class="text-right">
                    <!-- Actions -->
                    <div class="actions ml-3">
                      <a :uk-tooltip="$t('general.user_profil')" class="btn btn-icon btn-hover btn-sm btn-circle"
                        @click="openProfileModal(item)">
                        <i class="uil-user"></i>
                      </a>
                      <a v-if="$isSuperAdmin" :uk-tooltip="$t('general.user_account_login')"
                        class="btn btn-icon btn-hover btn-sm btn-circle" @click="openUserAccount(item)">
                        <i class="uil-eye "></i>
                      </a>
                      <a v-if="item.status_id !== 0" :style="{
                        cursor: $hasPermission('create_assignment') ? 'pointer' : 'not-allowed',
                        opacity: $hasPermission('create_assignment') ? 1 : 0.5
                      }" :uk-tooltip="$hasPermission('create_assignment')
  ? $t('general.assign_user_to_training')
  : $t('general.no_permission')" class="btn btn-icon btn-hover btn-sm btn-circle" type="button"
                        @click="$hasPermission('create_assignment') && openAssignmentModal(item.id)">
                        <i class="uil-location-arrow text-success"></i>
                      </a>

                      <a v-if="item.status_id !== 0" :uk-tooltip="$t('general.assign_to_group')"
                        class="btn btn-icon btn-hover btn-sm btn-circle" type="button" @click="openGroupModal(item.id)">
                        <i class="uil-user-square"></i>
                      </a>
                      <a v-if="item.status_id === 0" :uk-tooltip="$t('general.set_active')" aria-expanded="false"
                        class="btn btn-icon btn-hover btn-sm btn-circle" title="" @click="statusChange(item.id, 0)">
                        <i class="uil-minus-circle text-danger"></i>
                      </a>
                      <a v-else :uk-tooltip="$t('general.set_passive')" aria-expanded="false"
                        class="btn btn-icon btn-hover btn-sm btn-circle" title="" @click="statusChange(item.id, 1)">
                        <i class="uil-check text-success"></i>
                      </a>
                      <a :style="{
                        cursor: $hasPermission('delete_user') ? 'pointer' : 'not-allowed',
                        opacity: $hasPermission('delete_user') ? 1 : 0.5
                      }" :uk-tooltip="$hasPermission('delete_user')
  ? $t('collectionDetail.remove')
  : $t('general.no_permission')" aria-expanded="false" class="btn btn-icon btn-hover btn-sm btn-circle"
                        @click="$hasPermission('delete_user') && deleteUser(item.id)">
                        <i class="uil-trash text-danger"></i>
                      </a>

                      <a v-if="$isSuperAdmin" :uk-tooltip="$t('general.permissions')" aria-expanded="false"
                        class="btn btn-icon btn-hover btn-sm btn-circle" title="" @click="openPermissionModal()">
                        <i class="uil-key-skeleton"></i>
                      </a>

                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <div id="permission_modal" class="uk-modal" uk-modal>
          <div class="uk-modal-dialog bg-gray modal-container" style="width:50%">
            <div class="uk-padding-small uk-grid">
              <h2>{{ $t('general.permissions') }}</h2>
            </div>
            <div class="col-md-12">
              <h4>{{ $t('general.role_definition') }}</h4>
            </div>
            <div class="col-md-12" style="padding-bottom:4rem">
              <h4 style="margin:0">{{ $t('general.permissions') }}</h4>
              <table class="uk-table uk-table-divider uk-table-small " style="margin:0">
                <thead>
                  <tr>
                    <th></th>
                    <th>{{ $t('general.viewing') }}</th>
                    <th>{{ $t('general.add_action') }}</th>
                    <th>{{ $t('general.update_action') }}</th>
                    <th>{{ $t('general.delete_action') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(permission, index) in filteredPermissions" :key="index">
                    <td>
                      <label>
                        {{ permission.name }}
                      </label>
                    </td>
                    <td style="text-align: center;">
                      <i v-if="permission.actions.view" class="uil-key-skeleton"></i>
                      <i v-if="!permission.actions.view" class="uil-times"></i>
                    </td>
                    <td style="text-align: center;">
                      <i v-if="permission.actions.add" class="uil-key-skeleton"></i>
                      <i v-if="!permission.actions.add" class="uil-times"></i>
                    </td>
                    <td style="text-align: center;">
                      <i v-if="permission.actions.update" class="uil-key-skeleton"></i>
                      <i v-if="!permission.actions.update" class="uil-times"></i>
                    </td>
                    <td style="text-align: center;">
                      <i v-if="permission.actions.delete" class="uil-key-skeleton"></i>
                      <i v-if="!permission.actions.delete" class="uil-times"></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <AssignmentSelectionModal ref="assignmentModal" :assignment-data="assignments" :loading="assignment_loading"
          @assignment-selected="assignmentCreate" @page-changed="handleAssignmentPageChange"
          @search-changed="handleAssignmentSearch" />

        <pagination :pagination="pagination" class="mt-2 mb-3" @changePage="setPage($event)" />
      </template>
    </div>

    <UserGroupModal ref="groupModal" :groups="groups" :loading="group_loading" @group-selected="groupCreate" />

    <UserProfile v-if="activeItem && profileModalOpen" :key="`user-profile-${activeItem.id}-${profileRequestId}`"
      :item="activeItem" :loading="isLoadingUserDetail || !resolvedUserDetail" :user_detail="resolvedUserDetail"
      @assignmentPageChanged="handleUserAssignmentPageChange" @modalClosed="closeModal" @refresh="getUserDetail" />

  </div>
</template>

<script>
import SecureLS from "secure-ls";

const ls = new SecureLS({ encodingType: "aes", isCompression: true });
import module, {
  BASE_URL,
  GET_ITEMS,
  GET_COUNTS,
  COUNTS,
  ITEMS,
  LOADING,
  MODULE_NAME,
  SUCCESS,
  UPDATE_USER,
} from "@/core/services/store/user.module";

import user_detail_module, {
  GET_ITEM as GET_USER_DETAIL,
  ITEM as USER_DETAIL,
  MODULE_NAME as USER_DETAIL_MODULE,
} from "@/core/services/store/user_detail.module";

import assignment_module, {
  GET_ITEM as GET_ASSIGNMENT,
  ITEM as ASSIGNMENT_ITEM,
  MODULE_NAME as ASSIGNMENT_MODULE,
} from "@/core/services/store/assignment.module";

import group_module, {
  GET_ITEM as GET_GROUP,
  ITEM as GROUP_ITEM,
  MODULE_NAME as GROUP_MODULE,
} from "@/core/services/store/user_group.module";

import store from "@/core/services";
import moment from "moment";
import axios from "axios";
import Pagination from "@/assets/components/Pagination.vue";
import UserProfile from "@/view/company/User/UserProfile/index.vue";
import UserFilter from "@/view/company/User/Filter.vue";
import DefaultLoading from "@/view/components/loading/DefaultLoading.vue";
import company_module, {
  ONLINE_USERS,
  MODULE_NAME as COMPANY_MODULE,
} from "@/core/services/store/company.module";
import { confirmDialogDelete } from "@/utils/confirmDialog";
import AvatarOrIcon from "@/view/components/icons/AvatarOrIcon.vue";
import ExcelDownloadButton from "@/view/components/buttons/ExcelDownloadButton.vue";
import AssignmentSelectionModal from "@/view/company/User/components/AssignmentSelectionModal.vue";
import UserGroupModal from "@/view/company/User/components/UserGroupModal.vue";
import { showError } from "@/utils/alertUtils";
import {
  getAssignedCorporateAccess,
  applyAssignedCorporateToFilter
} from "@/core/services/userCorporateAccess.service";

const _USER_DETAIL_MODULE = USER_DETAIL_MODULE;
const _MODULE_NAME = MODULE_NAME;
const _ASSIGNMENT_MODULE = ASSIGNMENT_MODULE;
const _GROUP_MODULE = GROUP_MODULE;
const _COMPANY_MODULE = COMPANY_MODULE;

export default {
  name: "Users",
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(_MODULE_NAME, module);
    registerStoreModule(_USER_DETAIL_MODULE, user_detail_module);
    registerStoreModule(_ASSIGNMENT_MODULE, assignment_module);
    registerStoreModule(_GROUP_MODULE, group_module);
    registerStoreModule(_COMPANY_MODULE, company_module);
  },
  components: {
    ExcelDownloadButton,
    Pagination,
    UserProfile,
    UserFilter,
    DefaultLoading,
    AvatarOrIcon,
    AssignmentSelectionModal,
    UserGroupModal,
  },
  data() {
    return {
      isLoadingUserDetail: false,
      filteredPermissions: [
        {
          name: this.$t("users.users"),
          enabled: true,
          actions: {
            view: true,
            create: false,
            update: false,
            delete: false
          }
        },
        {
          name: this.$t("general.contents"),
          enabled: false,
          actions: {
            view: false,
            create: false,
            update: false,
            delete: false
          }
        },
        {
          name: this.$t("general.tags"),
          enabled: false,
          actions: {
            view: false,
            create: false,
            update: false,
            delete: false
          }
        },
        {
          name: this.$t("general.programs"),
          enabled: false,
          actions: {
            view: false,
            create: false,
            update: false,
            delete: false
          }
        },
        {
          name: this.$t("general.assignments"),
          enabled: false,
          actions: {
            view: false,
            create: false,
            update: false,
            delete: false
          }
        },
        {
          name: this.$t("general.catalog_trainings"),
          enabled: false,
          actions: {
            view: false,
            create: false,
            update: false,
            delete: false
          }
        },
        {
          name: this.$t("general.surveys"),
          enabled: false,
          actions: {
            view: false,
            create: false,
            update: false,
            delete: false
          }
        },
        {
          name: this.$t("exam.exams"),
          enabled: false,
          actions: {
            view: false,
            create: false,
            update: false,
            delete: false
          }
        }
      ],
      pagination: null,
      activeItem: null,
      activeUser: null,
      selectAllUserText: this.$t("general.select_all"),
      per_page: 10,
      filter: {
        search: null,
        order: "desc",
        sort: "id",
        company_id: null,
      },
      assignment_loading: null,
      group_loading: null,
      successMessage: "",
      item_checked: [],
      temp_page: [],
      checked_user_page: [],
      keepFilter: null,
      isReportDownloading: false,
      assignmentSearchQuery: '',
      profileModalOpen: false,
      profileDetailUserId: null,
      profileRequestId: 0
    };
  },
  computed: {
    user_header() {
      return JSON.parse(this.secureLocalStorage("user"));
    },
    shouldHideEmailField() {
      const companyId = this.filter?.company_id
        || this.activeItem?.company_id
        || this.resolvedUserDetail?.user?.company_id
        || this.user_header?.company_id;

      return Number(companyId) === 489;
    },
    onlineUsers() {
      return store.getters[_COMPANY_MODULE + "/" + ONLINE_USERS];
    },
    user_detail() {
      return store.getters[USER_DETAIL_MODULE + "/" + USER_DETAIL];
    },
    assignments() {
      return store.getters[ASSIGNMENT_MODULE + "/" + ASSIGNMENT_ITEM];
    },
    groups() {
      return store.getters[GROUP_MODULE + "/" + GROUP_ITEM];
    },
    items() {
      return store.getters[MODULE_NAME + "/" + ITEMS];
    },
    counts() {
      return store.getters[MODULE_NAME + "/" + COUNTS];
    },
    user_loading() {
      return store.getters[MODULE_NAME + "/" + LOADING];
    },
    success() {
      return store.getters[MODULE_NAME + "/" + SUCCESS];
    },
    formattedItem() {
      let results = [];
      if (this.items === null || !("data" in this.items)) return [];
      this.pagination = this.items;
      this.items.data.forEach((item) => {
        results.push({
          id: item.id,
          name: item.name,
          surname: item.surname,
          dob: item.dob ? item.dob : "-",
          email: item.email,
          group_info: item.groups,
          company_id: item.company_id,
          company_name: item.company ? item.company.name : "-",
          corporate_id: item.corporate_id,
          corporate_name: item.corporate ? item.corporate.name : null,
          position_id: item.position_id,
          title_id: item.title_id,
          region_id: item.region_id,
          department_id: item.department_id,
          branch_id: item.branch_id,
          status_id: item.status_id,
          is_online: !!this.onlineUsers.find((onlineUser) => onlineUser.user == item.id && onlineUser.status),
          photo_link: item.photo_link,
          fullname: [item.name, item.surname].join(" "),
          title: item.title ? item.title.name : "-",
          login_check_field: item.login_check_field
            ? item.login_check_field
            : "-",
          created_at: item.created_at
            ? moment(item.created_at).format("DD/MM/YYYY HH:mm:ss")
            : "-",
          last_login_at: item.last_login_at
            ? moment(item.last_login_at).format("DD/MM/YYYY HH:mm:ss")
            : "-",
          phone: this.getPhoneNumber(item)
        });
      });

      return results;
    },
    resolvedUserDetail() {
      if (!this.activeItem || !this.user_detail || !this.profileDetailUserId) {
        return null;
      }

      return this.activeItem.id === this.profileDetailUserId
        ? this.user_detail
        : null;
    },
    selectedUsersCount() {
      let userCount = this.item_checked.length;
      return userCount;
    },
  },
  methods: {
    sendForgotPasswordMail() {
      if (!this.item_checked || this.item_checked.length === 0) {
        return;
      }

      axios
        .post("/api/user/send-forgot-password-mail", {
          user_ids: this.item_checked
        })
        .then((response) => {
          const queuedUserCount = response.data.queued_user_count || 0;
          const skippedUserCount = response.data.skipped_user_count || 0;

          this.successMessage = true;

          if (queuedUserCount === 0) {
            this.successMessageText =
              this.$t("general.forgot_password_mail_all_skipped");
          } else if (skippedUserCount > 0) {
            this.successMessageText =
              this.$t("general.forgot_password_mail_queued_with_skipped", {
                queued: queuedUserCount,
                skipped: skippedUserCount,
              });
          } else {
            this.successMessageText =
              this.$t("general.forgot_password_mail_queued", {
                queued: queuedUserCount,
              });
          }

          this.item_checked = [];
          this.scrollToTop();
        })
        .catch((error) => {
          console.error(error);
        });
    },
    sendWelcomeMail() {
      if (!this.item_checked || this.item_checked.length === 0) {
        return;
      }
      axios
        .post("/api/user/send-welcome-mail", {
          user_ids: this.item_checked
        })
        .then((response) => {
          const queuedUserCount = response.data.queued_user_count || 0;
          const skippedUserCount = response.data.skipped_user_count || 0;

          this.successMessage = true;

          if (queuedUserCount === 0) {
            this.successMessageText =
              this.$t("general.welcome_mail_all_skipped");
          } else if (skippedUserCount > 0) {
            this.successMessageText =
              this.$t("general.welcome_mail_queued_with_skipped", {
                queued: queuedUserCount,
                skipped: skippedUserCount,
              });
          } else {
            this.successMessageText =
              this.$t("general.welcome_mail_queued", {
                queued: queuedUserCount,
              });
          }

          this.item_checked = [];
          this.scrollToTop();
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getPhoneNumber(user) {
      return (!user.country_phone_code || !user.phone) ? '-' : `+${user.country_phone_code}${user.phone}`;
    },
    getUserStatus(status) {
      if (status === 1) {
        return { text: this.$t('general.active'), className: 'active-user' }
      }
      return { text: this.$t('general.passive'), className: 'passive-user' }
    },
    openUserAccount(event) {
      let UserInfo = {
        "target_user_id": event.id
      }
      axios.post('api/impersonate',
        UserInfo, {
        headers: this.apiHeaders,
      })
        .then((response) => {
          let token = ls.get("token");
          this.$router.push({ path: "/dashboard" });
          if (!ls.get("superAdminToken")) ls.set("superAdminToken", token);
          ls.set("token", response.data.access_token);
        })
    },
    allUserToggle() {
      let self = this;
      let found = this.checked_user_page.find(
        (element) => element == this.items.current_page
      );

      if (
        this.temp_page.find((r) => r === this.items.current_page) == undefined
      ) {
        this.formattedItem.forEach((item) => {
          $("#notification_checkbox_" + item.id).prop("checked", true);

          let checked_status = this.item_checked.find((r) => r === item.id);

          if (!checked_status) self.item_checked.push(item.id);
        });

        if (!found) {
          this.checked_user_page.push(this.items.current_page);
        }

        this.selectAllUserText = this.$t("general.deselect_all");
        this.temp_page.push(this.items.current_page);
      } else {
        this.formattedItem.forEach((item) => {
          $("#notification_checkbox_" + item.id).prop("checked", false);
          this.item_checked = this.item_checked.filter(function (checked_user) {
            return checked_user !== item.id;
          });
        });
        this.checked_user_page = this.checked_user_page.filter(function (
          checked_page
        ) {
          return checked_page !== found;
        });
        this.selectAllUserText = this.$t("general.select_all");
        this.temp_page.forEach((e, i) => {
          if (e == self.items.current_page) {
            self.temp_page.splice(i, 1);
          }
        });
      }
    },

    async deleteSelectedUsers() {
      let self = this;

      const isConfirmed = await confirmDialogDelete({ context: this });

      if (isConfirmed) {
        let payload = {
          users: self.item_checked
        };

        axios.post(`/api/user/bulk-destroy`, payload, {
          headers: this.apiHeaders,
        }).then((response) => {
          this.filterResult();
          self.item_checked = [];
          this.getUserDetail()
          this.getCounts()
        });
      }
    },
    passiveSelectedUsers() {
      let self = this;
      if (self.item_checked.length > 0) {
        self.item_checked.forEach((element) => {
          self.statusChange(element, 1);
        });
        self.item_checked = [];
      }
    },
    activeSelectedUsers() {
      let self = this;
      if (self.item_checked.length > 0) {
        self.item_checked.forEach((element) => {
          self.statusChange(element, 0);
        });
        self.item_checked = [];
      }
    },
    assignmentCreate(assignmentId) {
      this.assignment_loading = true;
      axios
        .get(`/api/attach-user-assignment/${this.activeUser}/${assignmentId}`, {
          headers: this.apiHeaders,
        })
        .then(() => {
          this.getAssignmentItem(this.activeUser);
          this.assignment_loading = false;
        });
    },
    groupCreate(groupId) {
      this.group_loading = true;
      axios
        .get(`/api/attach-user-group/${this.activeUser}/${groupId}`, {
          headers: this.apiHeaders,
        })
        .then(() => {
          this.getGroupItem(this.activeUser);
          this.group_loading = false;
        });
    },
    openAssignmentModal(userId) {
      UIkit.modal("#assignment_selection_modal").show();
      this.activeUser = userId;
      this.getAssignmentItem(userId);
      this.assignment_loading = false;
    },
    openPermissionModal() {
      UIkit.modal("#permission_modal").show();
    },
    openGroupModal(userId) {
      this.activeUser = userId;
      this.group_loading = true;
      this.getGroupItem(userId);
    },
    getCounts() {
      this.$store.dispatch(MODULE_NAME + "/" + GET_COUNTS, {
        url: BASE_URL + "/counts",
      });
    },
    // Listeleme ve Excel export'un aynı filtrelerle çalışması için
    // aktif filtreden (keepFilter) tek noktada istek parametreleri üretilir
    buildRequestFilters() {
      const activeFilter = this.keepFilter || {};

      let filters = {
        like: this.filter.search,
        sort: this.filter.sort,
        order: this.filter.order,
        with_groups: true,
        status_id: activeFilter.user_status ?? null,
        from_date: activeFilter.from_date ?? null,
        to_date: activeFilter.to_date ?? null,
        position_id: activeFilter.position_id ?? null,
        title_id: activeFilter.title_id ?? null,
        region_id: activeFilter.region_id ?? null,
        department_id: activeFilter.department_id ?? null,
        branch_id: activeFilter.branch_id ?? null,
      };

      if (activeFilter.company_id) {
        filters['company_id'] = activeFilter.company_id;
      }

      // {id, name} listesi tutan filtreler API için id dizisine çevrilir
      $.each(activeFilter, function (key, value) {
        if (value && Array.isArray(value) && key !== 'company_id') {
          filters[key] = JSON.stringify(value.map((item) => item.id));
        }
      });

      return filters;
    },
    filterResult(filter = null, page = 1) {
      // Yeni filtre geldiyse sakla; gelmediyse (sayfalama, sıralama, yenileme)
      // en son uygulanan filtreyle devam et
      if (filter) {
        this.keepFilter = filter;
      }

      this.$store.dispatch(MODULE_NAME + "/" + GET_ITEMS, {
        url: BASE_URL,
        filters: {
          ...this.buildRequestFilters(),
          page: page,
          per_page: this.per_page,
        },
      });
    },
    sortOrder(order, sort) {
      this.filter.order = order;
      this.filter.sort = sort;

      this.filterResult();
    },
    setPage(page) {
      let found = this.checked_user_page.find((element) => element == page);
      if (found) {
        this.selectAllUserText = this.$t("general.deselect_all");
      } else {
        this.selectAllUserText = this.$t("general.select_all");
      }

      // Yeni filtre gönderme; keepFilter'daki son filtreyle sadece sayfa değişsin
      this.filterResult(null, page);
    },
    scrollToTop() {
      window.scroll({
        top: 0,
        behavior: "smooth",
      });
    },
    statusChange(id, status_id) {
      store.dispatch(MODULE_NAME + "/" + UPDATE_USER, {
        url: BASE_URL + "/status/" + id,
        contents: {
          user: id,
          status_id: status_id,
        },
        returnType: "stateless",
        acceptPromise: true,
        _method: "put",
      }).then(() => {
        setTimeout(() => {
          this.getCounts();

        }, 100);
      });
    },
    async deleteUser(id) {
      const isConfirmed = await confirmDialogDelete({ context: this });

      if (isConfirmed) {
        axios.delete(`/api/user/${id}`, {
          headers: this.apiHeaders,
        })
          .then((response) => {
            this.filterResult();
          });
      }
    },
    getUserDetail(id, assignmentsPage = 1, keepModalOpen = false, updateUrl = true) {
      if (!id) {
        return Promise.resolve();
      }

      // Eğer zaten yükleme yapılıyorsa, tekrar istek atma
      if (this.isLoadingUserDetail) {
        return Promise.resolve();
      }

      this.isLoadingUserDetail = true;

      // Pagination durumunda requestId'yi artırma (component yeniden mount olmasın)
      const requestId = keepModalOpen ? this.profileRequestId : ++this.profileRequestId;

      if (!keepModalOpen) {
        this.profileDetailUserId = null;
        this.profileModalOpen = true;
      }

      // URL güncelleme gerekiyorsa
      if (updateUrl) {
        const query = { profile: id };

        // keepModalOpen ise mevcut assignmentsPage'i koru, değilse yeni bir profil açılıyor demektir
        if (keepModalOpen && assignmentsPage !== 1) {
          query.assignmentsPage = assignmentsPage;
        } else if (!keepModalOpen) {
          // Yeni profil açılırken URL'deki assignmentsPage parametresini temizle
          // Ancak URL'de varsa onu kullan
          const urlAssignmentsPage = parseInt(this.$route.query.assignmentsPage);
          if (urlAssignmentsPage && urlAssignmentsPage > 1) {
            query.assignmentsPage = urlAssignmentsPage;
            assignmentsPage = urlAssignmentsPage;
          }
        }

        // Mevcut URL parametreleri ile yeni parametreleri karşılaştır
        const currentProfileId = parseInt(this.$route.query.profile);
        const currentAssignmentsPage = parseInt(this.$route.query.assignmentsPage) || 1;
        const newAssignmentsPage = parseInt(query.assignmentsPage) || 1;

        const shouldUpdateUrl = currentProfileId !== id || currentAssignmentsPage !== newAssignmentsPage;

        if (shouldUpdateUrl) {
          this.$router.push({
            name: 'company.user.list',
            query: { ...this.$route.query, ...query }
          }).catch(() => {
          });
        }
      }

      return store.dispatch(USER_DETAIL_MODULE + "/" + GET_USER_DETAIL, {
        url: "api/user/detail-admin" + "/" + id,
        filters: { page: assignmentsPage, perPage: 15 }
      }).then(() => {
        if (!keepModalOpen) {
          this.profileModalOpen = true;
        }
        if (requestId === this.profileRequestId && this.activeItem && this.activeItem.id === id) {
          this.profileDetailUserId = id;
        }
      }).catch(error => {
        if (requestId === this.profileRequestId) {
          this.profileModalOpen = false;
          this.profileDetailUserId = null;
        }
        console.error('getUserDetail error:', error);
      }).finally(() => {
        this.isLoadingUserDetail = false;
      })
    },
    getAssignmentItem(userId, page = 1, search = '') {
      store.dispatch(ASSIGNMENT_MODULE + "/" + GET_ASSIGNMENT, {
        url: `api/user-assignments/${userId}`,
        filters: { page: page, per_page: 10, search: search }
      });
    },
    handleAssignmentPageChange(page) {
      if (this.activeUser) {
        this.getAssignmentItem(this.activeUser, page, this.assignmentSearchQuery);
      }
    },
    handleAssignmentSearch(searchQuery) {
      this.assignmentSearchQuery = searchQuery;
      if (this.activeUser) {
        this.getAssignmentItem(this.activeUser, 1, searchQuery);
      }
    },
    getGroupItem(userId) {
      store.dispatch(GROUP_MODULE + "/" + GET_GROUP, {
        url: `api/user-groups/${userId}`,
      }).then(() => {
        this.$refs.groupModal.show();
      }).catch(() => {
        showError(this.$t('errors.error_occurred'))
      }).finally(() => {
        this.group_loading = false;
      })
    },
    getFilter(value) {
      this.filter.company_id = value.company_id;

      this.filterResult(value);
    },
    exportUsers() {
      if (this.isReportDownloading) {
        return;
      }
      this.isReportDownloading = true;

      let config = {
        responseType: "blob",
        headers: this.apiHeaders,
      };

      // Listede o an uygulanan filtrelerin aynısıyla export yapılır
      let data = this.buildRequestFilters();

      axios
        .post(
          process.env.VUE_APP_BACKEND_APP_URL + "/api/user/export",
          data,
          config
        )
        .then((response) => {
          let fileURL = window.URL.createObjectURL(new Blob([response.data]));
          let fileLink = document.createElement("a");

          fileLink.href = fileURL;
          let day = moment().format("YYYYMMDDHHMMSS");
          let fileName = "users_list_" + day + ".xlsx";
          fileLink.setAttribute("download", fileName);
          document.body.appendChild(fileLink);
          fileLink.click();

          this.isReportDownloading = false;
        })
        .catch(() => {
          this.isReportDownloading = false;
        });
    },
    async openProfileModal(item) {
      if (!item) return;

      this.activeItem = item;

      // Sadece URL'yi güncelle, getUserDetail watch tarafından çağrılacak
      this.$router.push({
        name: 'company.user.list',
        query: { ...this.$route.query, profile: item.id }
      }).catch(() => {
      });
    },
    async openProfileModalFromUrl(userId) {
      // Önce formattedItem içinde kullanıcıyı ara
      let user = this.formattedItem.find(item => item.id === userId);

      // URL'den assignmentsPage parametresini al
      const assignmentsPage = parseInt(this.$route.query.assignmentsPage) || 1;

      if (user) {
        // Kullanıcı mevcut sayfada varsa normal şekilde aç
        this.activeItem = user;
        try {
          // URL zaten değişti, tekrar değiştirme
          await this.getUserDetail(user.id, assignmentsPage, false, false);
          this.profileModalOpen = true;
        } catch (e) {
          console.error(e);
        }
      } else {
        // Kullanıcı mevcut sayfada yoksa, minimal bir activeItem oluştur
        this.activeItem = { id: userId };
        try {
          // URL zaten değişti, tekrar değiştirme
          await this.getUserDetail(userId, assignmentsPage, false, false);
          this.profileModalOpen = true;
        } catch (e) {
          console.error('URL\'den profil açılırken hata:', e);
        }
      }
    },
    handleUserAssignmentPageChange(page) {
      if (this.activeItem && this.activeItem.id) {
        // Sadece URL'yi güncelle, getUserDetail watch tarafından çağrılacak
        this.$router.push({
          name: 'company.user.list',
          query: { ...this.$route.query, assignmentsPage: page }
        }).catch(() => {
        });
      }
    },
    closeModal() {
      this.profileModalOpen = false;
      this.activeItem = null;
      this.profileDetailUserId = null;

      // URL'den profile ve assignmentsPage query parametrelerini kaldır
      const query = { ...this.$route.query };
      delete query.profile;
      delete query.assignmentsPage;

      this.$router.push({
        name: 'company.user.list',
        query
      }).catch(() => {
      });
    }
  },
  async mounted() {
    // company_admin değilse ve bir şirkete atanmışsa ilk listede sadece o şirket gelsin
    const corporateAccess = await getAssignedCorporateAccess();
    this.keepFilter = applyAssignedCorporateToFilter(this.keepFilter, corporateAccess);
    this.filterResult();
    this.getCounts();
    this.debouncedFilterSearch = _.debounce(this.filterResult, 500);

    // Groups modalı dinleme
    this.$nextTick(() => {
      const groupModal = document.getElementById('group_modal');
      if (groupModal) {
        UIkit.util.on(groupModal, 'hidden', () => {
          this.filterResult();
        });
      }

      const assignmentModal = document.getElementById('assignment_selection_modal');
      if (assignmentModal) {
        UIkit.util.on(assignmentModal, 'hidden', () => {
          if (this.$refs.assignmentModal) {
            this.$refs.assignmentModal.searchQuery = '';
          }
        });
      }
    });

    if (this.$route.params.succesMessage != null) {
      this.successMessage = true;
      this.successMessageText = this.$route.params.succesMessage;
      this.scrollToTop();
    }

    // URL'de profile query parametresi varsa modal'ı aç
    if (this.$route.query.profile) {
      const userId = parseInt(this.$route.query.profile);
      if (userId) {
        this.openProfileModalFromUrl(userId);
      }
    }
  },
  watch: {
    success: function (val) {
      if (val) {
        this.filterResult();
      }
    },
    "filter.search": function () {
      this.debouncedFilterSearch();
    },
    '$route.query.profile': function (newProfileId, oldProfileId) {
      if (newProfileId && newProfileId !== oldProfileId) {
        // Yeni profil ID'si varsa modal'ı aç
        const userId = parseInt(newProfileId);
        // Eğer activeItem zaten bu kullanıcıysa ve modal açıksa, tekrar açma
        if (userId && (!this.activeItem || this.activeItem.id !== userId || !this.profileModalOpen)) {
          this.openProfileModalFromUrl(userId);
        }
      } else if (!newProfileId && oldProfileId && this.profileModalOpen) {
        // Profil ID'si kaldırıldıysa ve modal açıksa, modal'ı kapat
        const modalElement = document.getElementById('modal-profile');
        if (modalElement) {
          const modal = UIkit.modal(modalElement);
          if (modal && modal.isToggled()) {
            modal.hide();
          }
        }
        this.profileModalOpen = false;
        this.activeItem = null;
        this.profileDetailUserId = null;
      }
    },
    '$route.query.assignmentsPage': function (newPage, oldPage) {
      // Type-safe karşılaştırma için integer'a çevir
      const newPageNum = parseInt(newPage) || 0;
      const oldPageNum = parseInt(oldPage) || 0;

      // Assignment page değiştiğinde ve modal açıksa, verileri yenile
      if (newPageNum && newPageNum !== oldPageNum && this.profileModalOpen && this.activeItem) {
        // keepModalOpen = true, updateUrl = false (URL zaten değişti)
        this.getUserDetail(this.activeItem.id, newPageNum, true, false);
      }
    },
  },
  beforeDestroy() {
    const modalAssignment = UIkit.modal("#assignment_selection_modal");
    if (modalAssignment) modalAssignment.$destroy(true);
  },
};
</script>

<style scoped>
@import "~vue-multiselect/dist/vue-multiselect.min.css";

.multiselect__tag {
  color: white;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  background-color: #3e416d;
}

.multiselect__tag-icon {
  background-color: transparent;
  line-height: 2.2;
}

.multiselect__tag-icon:after {
  color: #fff;
}

.multiselect__tag-icon:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

.multiselect__input {
  border: unset !important;
}

.multiselect__tags .multiselect__input {
  border: unset !important;
}

input[type="button"],
input[type="submit"],
span.btn,
.btn {
  display: inline-block;
}

.uk-alert {
  margin: 0;
}

.bg-offline {
  background-color: #c0c0c0 !important;
}

table tbody tr:nth-child(even) {
  background-color: #f2f2f2;
}

table tbody tr:nth-child(odd) {
  background-color: #ffffff;
}

/* User Status Colors */
.active-user {
  color: #28a745 !important;
  font-weight: 600;
}

.passive-user {
  color: #dc3545 !important;
  font-weight: 600;
}

@media (max-width: 960px) {
  .users-toolbar {
    padding: 16px;
  }

  .users-toolbar-inner {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
  }

  .users-toolbar-search {
    width: 100%;
  }

  .users-toolbar-search .uk-search-input {
    min-height: 48px;
    font-size: 16px;
  }

  .users-toolbar-actions {
    flex-wrap: wrap;
    gap: 8px;
    width: 100%;
  }

  .users-toolbar-actions>* {
    min-height: 44px;
  }

  .users-bulk-actions {
    flex-wrap: wrap;
    gap: 8px;
  }

  .users-bulk-actions .btn {
    min-height: 44px;
    width: 100%;
    margin: 0 !important;
  }
}
</style>
